// frontend/src/modules/empresas/components/RegisterCompanyWizard.js
import React, { useState } from 'react';
import { validarCNPJ, formatarCNPJ } from '../../../services/validators';

function RegisterCompanyWizard({ onRegister, onCancel }) {
  const [etapa, setEtapa] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [formData, setFormData] = useState({
    // Etapa 1 - Dados da Empresa
    tipo_empresa: '',
    natureza_juridica: '',
    nome_fantasia: '',
    razao_social: '',
    cnpj: '',
    data_abertura: '',
    inscricao_estadual: '',
    inscricao_municipal: '',
    regime_tributario: 'SIMPLES_NACIONAL',
    capital_social: 0,
    // Etapa 2 - Endereço
    cep: '',
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
    pais: 'Brasil',
    // Etapa 3 - CNAE
    cnae_principal: '',
    cnae_descricao: '',
    // Etapa 4 - Contato
    telefone: '',
    email: '',
    site: '',
    // Etapa 5 - Documentos
    contrato_social: null,
    comprovante_cnpj: null,
    inscricao_estadual_doc: null
  });

  const totalEtapas = 6;
  const progress = (etapa / totalEtapas) * 100;

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'file' ? files[0] : value
    });
  };

  const proximaEtapa = () => {
    if (etapa < totalEtapas) setEtapa(etapa + 1);
  };

  const etapaAnterior = () => {
    if (etapa > 1) setEtapa(etapa - 1);
  };

  // ✅ FUNÇÃO DE SUBMIT CORRIGIDA
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        throw new Error('Usuário não autenticado. Faça login novamente.');
      }

      // ✅ URL CORRETA - PORTA 3001
      const API_URL = '';
      
      const empresaData = {
        nome: formData.nome_fantasia || formData.razao_social,
        razao_social: formData.razao_social,
        nome_fantasia: formData.nome_fantasia,
        cnpj: formData.cnpj.replace(/[^0-9]/g, ''),
        tipo_empresa: formData.tipo_empresa,
        natureza_juridica: formData.natureza_juridica,
        data_abertura: formData.data_abertura,
        inscricao_estadual: formData.inscricao_estadual,
        inscricao_municipal: formData.inscricao_municipal,
        regime_tributario: formData.regime_tributario,
        capital_social: parseFloat(formData.capital_social) || 0,
        cep: formData.cep,
        logradouro: formData.logradouro,
        numero: formData.numero,
        complemento: formData.complemento,
        bairro: formData.bairro,
        cidade: formData.cidade,
        estado: formData.estado,
        pais: formData.pais,
        endereco: `${formData.logradouro}, ${formData.numero}${formData.complemento ? ` - ${formData.complemento}` : ''} - ${formData.bairro}, ${formData.cidade}/${formData.estado}`,
        cnae_principal: formData.cnae_principal,
        cnae_descricao: formData.cnae_descricao,
        telefone: formData.telefone,
        email: formData.email,
        site: formData.site,
        ativo: true
      };

      console.log('📦 Enviando para:', `${API_URL}/api/empresas`);
      console.log('📦 Dados:', empresaData);

      // ✅ CHAMADA CORRETA
      const response = await fetch(`${API_URL}/api/empresas`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(empresaData)
      });

      // ✅ VERIFICAR SE A RESPOSTA É JSON
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('❌ Resposta não é JSON:', text.substring(0, 200));
        throw new Error('Erro no servidor. Verifique se o backend está rodando na porta 3001.');
      }

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Erro ao cadastrar empresa');
      }

      setSuccess('✅ Empresa cadastrada com sucesso!');
      
      if (data.empresa) {
        localStorage.setItem('empresa', JSON.stringify(data.empresa));
      }
      
      setTimeout(() => {
        if (onRegister) onRegister();
      }, 2000);
      
    } catch (err) {
      console.error('❌ Erro detalhado:', err);
      setError(err.message || 'Erro ao cadastrar empresa');
    } finally {
      setLoading(false);
    }
  };

  // ========== STYLES ==========
  const styles = {
    container: {
      maxWidth: '800px',
      margin: '0 auto',
      padding: '20px',
    },
    title: {
      fontSize: 'clamp(1.3rem, 4vw, 2rem)',
      marginBottom: '20px',
      color: '#333'
    },
    progressContainer: {
      marginBottom: '30px'
    },
    stepIndicators: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '10px',
      padding: '0 10px'
    },
    stepNumber: {
      fontSize: 'clamp(0.8rem, 1.2vw, 1rem)',
      fontWeight: 'normal',
      transition: 'all 0.3s ease',
      cursor: 'pointer'
    },
    progressBar: {
      width: '100%',
      height: '8px',
      backgroundColor: '#e9ecef',
      borderRadius: '4px',
      overflow: 'hidden',
      position: 'relative'
    },
    progressFill: {
      height: '100%',
      backgroundColor: '#28a745',
      transition: 'width 0.5s ease',
      borderRadius: '4px'
    },
    progressText: {
      textAlign: 'center',
      marginTop: '10px',
      fontSize: 'clamp(0.8rem, 1.2vw, 1rem)',
      color: '#6c757d'
    },
    errorMessage: {
      backgroundColor: '#ffebee',
      padding: '10px 15px',
      borderRadius: '4px',
      color: '#c62828',
      marginBottom: '15px',
      fontSize: 'clamp(0.85rem, 1.2vw, 1rem)',
      wordBreak: 'break-word'
    },
    successMessage: {
      backgroundColor: '#e8f5e9',
      padding: '10px 15px',
      borderRadius: '4px',
      color: '#2e7d32',
      marginBottom: '15px',
      fontSize: 'clamp(0.85rem, 1.2vw, 1rem)',
      wordBreak: 'break-word'
    },
    stepTitle: {
      fontSize: 'clamp(1.1rem, 2.5vw, 1.5rem)',
      marginTop: 0,
      marginBottom: '5px',
      color: '#333'
    },
    stepDescription: {
      fontSize: 'clamp(0.9rem, 1.2vw, 1rem)',
      color: '#6c757d',
      marginBottom: '20px'
    },
    formGroup: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    },
    label: {
      fontWeight: '500',
      marginBottom: '5px',
      fontSize: 'clamp(0.85rem, 1.2vw, 1rem)',
      color: '#333'
    },
    input: {
      width: '100%',
      padding: '10px 12px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      fontSize: 'clamp(0.9rem, 1.2vw, 1rem)',
      transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
      boxSizing: 'border-box',
      backgroundColor: '#fff'
    },
    select: {
      width: '100%',
      padding: '10px 12px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      fontSize: 'clamp(0.9rem, 1.2vw, 1rem)',
      backgroundColor: '#fff',
      transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
      boxSizing: 'border-box'
    },
    fileInput: {
      width: '100%',
      padding: '8px 12px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      fontSize: 'clamp(0.85rem, 1.2vw, 1rem)',
      backgroundColor: '#fff',
      cursor: 'pointer',
      boxSizing: 'border-box'
    },
    fileUploaded: {
      display: 'block',
      marginTop: '5px',
      color: '#28a745',
      fontSize: 'clamp(0.85rem, 1.2vw, 1rem)'
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '30px',
      gap: '10px',
      flexWrap: 'wrap'
    },
    backButton: {
      padding: '12px 25px',
      backgroundColor: '#6c757d',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: 'clamp(0.9rem, 1.2vw, 1rem)',
      transition: 'all 0.3s ease',
      fontWeight: '500',
      flex: '1',
      minWidth: '120px'
    },
    backButtonDisabled: {
      padding: '12px 25px',
      backgroundColor: '#e9ecef',
      color: '#6c757d',
      border: 'none',
      borderRadius: '4px',
      cursor: 'not-allowed',
      fontSize: 'clamp(0.9rem, 1.2vw, 1rem)',
      fontWeight: '500',
      flex: '1',
      minWidth: '120px'
    },
    nextButton: {
      padding: '12px 25px',
      backgroundColor: '#007bff',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: 'clamp(0.9rem, 1.2vw, 1rem)',
      transition: 'all 0.3s ease',
      fontWeight: '500',
      flex: '1',
      minWidth: '120px'
    },
    submitButton: {
      padding: '12px 25px',
      backgroundColor: '#28a745',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: 'clamp(0.9rem, 1.2vw, 1rem)',
      transition: 'all 0.3s ease',
      fontWeight: '500',
      flex: '1',
      minWidth: '120px'
    },
    submitButtonDisabled: {
      padding: '12px 25px',
      backgroundColor: '#6c757d',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'not-allowed',
      fontSize: 'clamp(0.9rem, 1.2vw, 1rem)',
      fontWeight: '500',
      flex: '1',
      minWidth: '120px'
    },
    cancelButton: {
      marginTop: '15px',
      padding: '10px 20px',
      backgroundColor: 'transparent',
      color: '#6c757d',
      border: '1px solid #6c757d',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: 'clamp(0.85rem, 1.2vw, 1rem)',
      transition: 'all 0.3s ease',
      width: 'auto'
    },
    validationError: {
      color: '#dc3545',
      fontSize: 'clamp(0.75rem, 1vw, 0.85rem)',
      marginTop: '4px'
    },
    smallText: {
      display: 'block',
      fontSize: 'clamp(0.75rem, 1vw, 0.85rem)',
      color: '#6c757d',
      marginTop: '4px'
    },
    required: {
      color: '#dc3545',
      marginLeft: '2px'
    },
    gridWrapper: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '15px'
    }
  };

  // ========== RENDER ETAPAS ==========
  const renderEtapa = () => {
    const renderGrid = (children) => (
      <div style={styles.gridWrapper}>
        {children}
      </div>
    );

    switch(etapa) {
      case 1:
        return (
          <div>
            <h3 style={styles.stepTitle}>🏢 Etapa 1: Dados da Empresa</h3>
            <p style={styles.stepDescription}>Informe os dados básicos da empresa.</p>
            {renderGrid([
              <div key="tipo" style={styles.formGroup}>
                <label style={styles.label}>Tipo de Empresa <span style={styles.required}>*</span></label>
                <select name="tipo_empresa" value={formData.tipo_empresa} onChange={handleChange} style={styles.select}>
                  <option value="">Selecione...</option>
                  <option value="MEI">MEI</option>
                  <option value="EI">Empresário Individual</option>
                  <option value="EIRELI">EIRELI</option>
                  <option value="LTDA">Sociedade Limitada</option>
                  <option value="SA">Sociedade Anônima</option>
                </select>
              </div>,
              <div key="natureza" style={styles.formGroup}>
                <label style={styles.label}>Natureza Jurídica <span style={styles.required}>*</span></label>
                <input name="natureza_juridica" value={formData.natureza_juridica} onChange={handleChange} placeholder="Ex: Sociedade Empresária Limitada" style={styles.input} />
              </div>,
              <div key="fantasia" style={styles.formGroup}>
                <label style={styles.label}>Nome Fantasia <span style={styles.required}>*</span></label>
                <input name="nome_fantasia" value={formData.nome_fantasia} onChange={handleChange} placeholder="Nome comercial da empresa" style={styles.input} />
              </div>,
              <div key="razao" style={styles.formGroup}>
                <label style={styles.label}>Razão Social <span style={styles.required}>*</span></label>
                <input name="razao_social" value={formData.razao_social} onChange={handleChange} placeholder="Nome oficial da empresa" style={styles.input} />
              </div>,
              <div key="cnpj" style={styles.formGroup}>
                <label style={styles.label}>CNPJ <span style={styles.required}>*</span></label>
                <input name="cnpj" value={formData.cnpj} onChange={(e) => setFormData({...formData, cnpj: formatarCNPJ(e.target.value)})} placeholder="00.000.000/0001-00" style={styles.input} />
                <span style={styles.smallText}>Formato: 00.000.000/0001-00</span>
              </div>,
              <div key="data" style={styles.formGroup}>
                <label style={styles.label}>Data de Abertura <span style={styles.required}>*</span></label>
                <input name="data_abertura" value={formData.data_abertura} onChange={handleChange} type="date" style={styles.input} />
              </div>,
              <div key="ie" style={styles.formGroup}>
                <label style={styles.label}>Inscrição Estadual</label>
                <input name="inscricao_estadual" value={formData.inscricao_estadual} onChange={handleChange} placeholder="Número da inscrição estadual" style={styles.input} />
              </div>,
              <div key="im" style={styles.formGroup}>
                <label style={styles.label}>Inscrição Municipal</label>
                <input name="inscricao_municipal" value={formData.inscricao_municipal} onChange={handleChange} placeholder="Número da inscrição municipal" style={styles.input} />
              </div>,
              <div key="regime" style={styles.formGroup}>
                <label style={styles.label}>Regime Tributário <span style={styles.required}>*</span></label>
                <select name="regime_tributario" value={formData.regime_tributario} onChange={handleChange} style={styles.select}>
                  <option value="SIMPLES_NACIONAL">Simples Nacional</option>
                  <option value="LUCRO_PRESUMIDO">Lucro Presumido</option>
                  <option value="LUCRO_REAL">Lucro Real</option>
                  <option value="MEI">MEI</option>
                </select>
              </div>,
              <div key="capital" style={styles.formGroup}>
                <label style={styles.label}>Capital Social (R$) <span style={styles.required}>*</span></label>
                <input name="capital_social" value={formData.capital_social} onChange={handleChange} type="number" step="0.01" placeholder="0,00" style={styles.input} />
              </div>
            ])}
          </div>
        );

      case 2:
        return (
          <div>
            <h3 style={styles.stepTitle}>📍 Etapa 2: Endereço</h3>
            <p style={styles.stepDescription}>Informe o endereço da empresa.</p>
            {renderGrid([
              <div key="cep" style={styles.formGroup}>
                <label style={styles.label}>CEP <span style={styles.required}>*</span></label>
                <input name="cep" value={formData.cep} onChange={handleChange} placeholder="00000-000" style={styles.input} />
              </div>,
              <div key="logradouro" style={styles.formGroup}>
                <label style={styles.label}>Logradouro <span style={styles.required}>*</span></label>
                <input name="logradouro" value={formData.logradouro} onChange={handleChange} placeholder="Rua, Avenida..." style={styles.input} />
              </div>,
              <div key="numero" style={styles.formGroup}>
                <label style={styles.label}>Número <span style={styles.required}>*</span></label>
                <input name="numero" value={formData.numero} onChange={handleChange} placeholder="Número" style={styles.input} />
              </div>,
              <div key="complemento" style={styles.formGroup}>
                <label style={styles.label}>Complemento</label>
                <input name="complemento" value={formData.complemento} onChange={handleChange} placeholder="Sala, Bloco, ..." style={styles.input} />
              </div>,
              <div key="bairro" style={styles.formGroup}>
                <label style={styles.label}>Bairro <span style={styles.required}>*</span></label>
                <input name="bairro" value={formData.bairro} onChange={handleChange} placeholder="Bairro" style={styles.input} />
              </div>,
              <div key="cidade" style={styles.formGroup}>
                <label style={styles.label}>Cidade <span style={styles.required}>*</span></label>
                <input name="cidade" value={formData.cidade} onChange={handleChange} placeholder="Cidade" style={styles.input} />
              </div>,
              <div key="estado" style={styles.formGroup}>
                <label style={styles.label}>Estado <span style={styles.required}>*</span></label>
                <select name="estado" value={formData.estado} onChange={handleChange} style={styles.select}>
                  <option value="">Selecione...</option>
                  <option value="AC">Acre</option><option value="AL">Alagoas</option>
                  <option value="AP">Amapá</option><option value="AM">Amazonas</option>
                  <option value="BA">Bahia</option><option value="CE">Ceará</option>
                  <option value="DF">Distrito Federal</option><option value="ES">Espírito Santo</option>
                  <option value="GO">Goiás</option><option value="MA">Maranhão</option>
                  <option value="MT">Mato Grosso</option><option value="MS">Mato Grosso do Sul</option>
                  <option value="MG">Minas Gerais</option><option value="PA">Pará</option>
                  <option value="PB">Paraíba</option><option value="PR">Paraná</option>
                  <option value="PE">Pernambuco</option><option value="PI">Piauí</option>
                  <option value="RJ">Rio de Janeiro</option><option value="RN">Rio Grande do Norte</option>
                  <option value="RS">Rio Grande do Sul</option><option value="RO">Rondônia</option>
                  <option value="RR">Roraima</option><option value="SC">Santa Catarina</option>
                  <option value="SP">São Paulo</option><option value="SE">Sergipe</option>
                  <option value="TO">Tocantins</option>
                </select>
              </div>,
              <div key="pais" style={styles.formGroup}>
                <label style={styles.label}>País</label>
                <input name="pais" value={formData.pais} onChange={handleChange} style={styles.input} />
              </div>
            ])}
          </div>
        );

      case 3:
        return (
          <div>
            <h3 style={styles.stepTitle}>📊 Etapa 3: Atividades (CNAE)</h3>
            <p style={styles.stepDescription}>Informe a atividade principal da empresa.</p>
            {renderGrid([
              <div key="cnae" style={styles.formGroup}>
                <label style={styles.label}>CNAE Principal <span style={styles.required}>*</span></label>
                <input name="cnae_principal" value={formData.cnae_principal} onChange={handleChange} placeholder="Ex: 6201-5/01" style={styles.input} />
                <span style={styles.smallText}>Exemplo: 6201-5/01</span>
              </div>,
              <div key="cnae_desc" style={styles.formGroup}>
                <label style={styles.label}>Descrição da Atividade</label>
                <input name="cnae_descricao" value={formData.cnae_descricao} onChange={handleChange} placeholder="Descrição da atividade principal" style={styles.input} />
              </div>
            ])}
          </div>
        );

      case 4:
        return (
          <div>
            <h3 style={styles.stepTitle}>📞 Etapa 4: Contato</h3>
            <p style={styles.stepDescription}>Informe os dados de contato da empresa.</p>
            {renderGrid([
              <div key="telefone" style={styles.formGroup}>
                <label style={styles.label}>Telefone</label>
                <input name="telefone" value={formData.telefone} onChange={handleChange} placeholder="(11) 99999-9999" style={styles.input} />
                <span style={styles.smallText}>Formato: (DD) 99999-9999</span>
              </div>,
              <div key="email" style={styles.formGroup}>
                <label style={styles.label}>Email <span style={styles.required}>*</span></label>
                <input name="email" value={formData.email} onChange={handleChange} type="email" placeholder="contato@empresa.com" style={styles.input} />
              </div>,
              <div key="site" style={styles.formGroup}>
                <label style={styles.label}>Site</label>
                <input name="site" value={formData.site} onChange={handleChange} placeholder="www.empresa.com" style={styles.input} />
              </div>
            ])}
          </div>
        );

      case 5:
        return (
          <div>
            <h3 style={styles.stepTitle}>💰 Etapa 5: Capital Social</h3>
            <p style={styles.stepDescription}>Informe o capital social da empresa.</p>
            {renderGrid([
              <div key="capital" style={styles.formGroup}>
                <label style={styles.label}>Capital Social (R$) <span style={styles.required}>*</span></label>
                <input name="capital_social" value={formData.capital_social} onChange={handleChange} type="number" step="0.01" placeholder="0,00" style={styles.input} />
                <span style={styles.smallText}>Valor total do capital social da empresa.</span>
              </div>
            ])}
          </div>
        );

      case 6:
        return (
          <div>
            <h3 style={styles.stepTitle}>📄 Etapa 6: Documentos</h3>
            <p style={styles.stepDescription}>Envie os documentos necessários para a abertura.</p>
            {renderGrid([
              <div key="contrato" style={styles.formGroup}>
                <label style={styles.label}>Contrato Social <span style={styles.required}>*</span></label>
                <input type="file" name="contrato_social" onChange={handleChange} style={styles.fileInput} accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" />
                {formData.contrato_social && <span style={styles.fileUploaded}>✅ {formData.contrato_social.name}</span>}
                <span style={styles.smallText}>Formatos: PDF, DOC, DOCX, JPG, PNG</span>
              </div>,
              <div key="comprovante" style={styles.formGroup}>
                <label style={styles.label}>Comprovante de CNPJ <span style={styles.required}>*</span></label>
                <input type="file" name="comprovante_cnpj" onChange={handleChange} style={styles.fileInput} accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" />
                {formData.comprovante_cnpj && <span style={styles.fileUploaded}>✅ {formData.comprovante_cnpj.name}</span>}
                <span style={styles.smallText}>Formatos: PDF, DOC, DOCX, JPG, PNG</span>
              </div>,
              <div key="ie_doc" style={styles.formGroup}>
                <label style={styles.label}>Inscrição Estadual</label>
                <input type="file" name="inscricao_estadual_doc" onChange={handleChange} style={styles.fileInput} accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" />
                {formData.inscricao_estadual_doc && <span style={styles.fileUploaded}>✅ {formData.inscricao_estadual_doc.name}</span>}
                <span style={styles.smallText}>Formatos: PDF, DOC, DOCX, JPG, PNG (opcional)</span>
              </div>
            ])}
          </div>
        );

      default:
        return null;
    }
  };

  // ========== RENDER PRINCIPAL ==========
  return (
    <div style={styles.container}>
      <h2 style={styles.title}>🏢 Cadastro Completo de Empresa</h2>
      
      <div style={styles.progressContainer}>
        <div style={styles.stepIndicators}>
          {Array.from({ length: totalEtapas }, (_, i) => (
            <span key={i} style={{ ...styles.stepNumber, color: i + 1 <= etapa ? '#28a745' : '#6c757d', fontWeight: i + 1 === etapa ? 'bold' : 'normal' }}>
              {i + 1}
            </span>
          ))}
        </div>
        <div style={styles.progressBar}>
          <div style={{...styles.progressFill, width: `${progress}%`}} />
        </div>
        <p style={styles.progressText}>Etapa {etapa} de {totalEtapas}</p>
      </div>

      {error && <div style={styles.errorMessage}>❌ {error}</div>}
      {success && <div style={styles.successMessage}>✅ {success}</div>}

      <form onSubmit={handleSubmit}>
        {renderEtapa()}

        <div style={styles.buttonContainer}>
          <button type="button" onClick={etapaAnterior} disabled={etapa === 1} style={etapa === 1 ? styles.backButtonDisabled : styles.backButton}>
            ← Voltar
          </button>

          {etapa < totalEtapas ? (
            <button type="button" onClick={proximaEtapa} style={styles.nextButton}>
              Próximo →
            </button>
          ) : (
            <button type="submit" disabled={loading} style={loading ? styles.submitButtonDisabled : styles.submitButton}>
              {loading ? '⏳ Cadastrando...' : '✅ Concluir Cadastro'}
            </button>
          )}
        </div>
      </form>

      <button onClick={onCancel} style={styles.cancelButton}>
        Cancelar
      </button>
    </div>
  );
}

export default RegisterCompanyWizard;